<template>
    <section>
        <ul class="lesson_list">
            <li v-for="(item, index) in lessonArray" :key="index"
                @click="lessonClick(item.pk)">
                <div class="lesson_item_left">
                    <img  :src="$qiNiuDomainBase + item.picture"/>
                </div>
                <div class="lesson_item_center">
                    <div class="name">
                        {{'第' + item.lessonNo + '课' + ' ' + item.englishName}}
                    </div>
                    <div class="introduction">{{item.introduction}}</div>
                </div>
                <div class="lesson_item_right">
                    <img class="img1" src="@/assets/growth_right.png" height="12.5" width="8"/>
                    <img class="img2" v-if="getCount(item.finish) === 1" src="@/assets/240_course_finished.png" height="48"
                         width="60"/>
                </div>
                <div class="clear"></div>
                <div v-if="getCount(isFreeTrial) === 1" class="free_trial">可试听</div>
            </li>
        </ul>
    </section>
</template>

<script>
    export default {
        props: {
            lessonArray: {
                type: Array,
                default:() => []
            },
            totalPartCount:{
                type: String,
                default: '0'
            },
            courseId:{
                type: String,
                default: '0'
            },
            isFreeTrial:{
                type: String,
                default: '0'
            }
        },
        methods: {
            lessonClick(pk) {
                this.$emit('lessonClick', pk);
            }
        }
    }
</script>

<style scoped>
    .free_trial {
        position: absolute;
        top: 0;
        right:0;
        background-color: #ff5a50;
        font-size: 13px;
        font-weight: bold;
        color: white;
        padding: 2px 5px 2px 5px;
    }
    .lesson_list:first-child {
        padding-top: 15px;
    }
    .lesson_list:last-child {
        padding-top: 15px;
    }
    .lesson_list li {
        background-color: white;
        margin: 0px 10px 15px 10px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        padding: 15px;
        position: relative;
    }
    .lesson_list li .lesson_item_left {
        float: left;
        width: 80px;
        height:80px;
    }
    .lesson_list li .lesson_item_left img {
        width: 100%;
    }
    .lesson_list li .lesson_item_center {
        float: left;
        margin-left: 10px;
        width: calc(100% - 110px);
    }
    .lesson_list li .lesson_item_center .name {
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        color: #000;
    }
    .lesson_list li .lesson_item_center .introduction {
        text-align: left;
        font-size: 13px;
        color: #666666;
    }
    .lesson_list li .lesson_item_center div {

    }
    .lesson_list li .lesson_item_right {
        width: 50px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
    }
    .lesson_list li .lesson_item_right .img1 {
        position: absolute;
        top: 50%;
        right: 15px;
        -webkit-transform: translateY(-50%);
    }
    .lesson_list li .lesson_item_right .img2 {
        position: absolute;
        top: 5px;
        right: 15px;
        -webkit-transform: translateY(5px);
    }
    .lesson_list li .lesson_item_right span {
        position: absolute;
        right: 15px;
        bottom: 15px;
        font-size: 15px;
        color: #999999;
    }
</style>